<template>
  <div>
    <transition name="fade">
      <div :class="[ 'overlay' ]" v-if="open" v-on:click="close"></div>
    </transition>
    <transition name="slide">
      <div class="body" v-if="open">
        <form class="form" v-on:submit="save">
          <div class="top">
            <div class="title">
              <button class="btn" type="button" v-on:click="close">
                <svg width="19px" height="16px" viewBox="0 0 19 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="Suites-Availability-Add" transform="translate(-913.000000, -68.000000)">
                      <g id="Group-14" transform="translate(50.000000, 70.000000)"></g>
                      <g id="Back" transform="translate(922.500000, 76.000000) rotate(-270.000000) translate(-922.500000, -76.000000) translate(915.000000, 67.000000)" fill="#000000">
                        <polygon id="Path" points="13.2657054 9.9079646 8.2218255 14.9734513 8.12482781 0 6.63752989 0.0318584071 6.60519733 15.0371681 1.49665229 9.93982301 0.397345133 11.0230088 7.38117885 18 14.3973451 10.9911504"></polygon>
                      </g>
                    </g>
                  </g>
                </svg>
              </button>
              <span v-if="!suite || !suite.id">Add New Suite</span>
              <span v-else>Edit Suite {{ suite.unit }}</span>
            </div>
            <div id="upload">
              <div v-if="!hasUploadedFile">
                <img src="@/assets/icons/upload.svg" alt="Upload" />
                <span class="large" v-if="suite">Drag and drop to upload <strong>new</strong> floor plan</span>
                <span class="large" v-else>Drag and drop to upload floor plan</span>
                <span class="small">or <strong>browse</strong> for the file</span>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="form-group row">
              <label for="isSuiteType" class="col-form-label col-md-4">This is a suite type</label>
              <div class="col-md-8 suite-type-col">
                <label class="check">
                  <input type="checkbox" name="endDate" id="endDate" v-model="isSuiteType" />
                  <span></span>
                </label>
              </div>
            </div>
            <div class="form-group row" v-if="isSuiteType">
              <label for="suite-type-name" class="col-form-label col-md-3">Name:</label>
              <div class="col-md-9">
                <input type="text" name="suite-type-name" id="suite-type-name" v-model="name" class="form-control" placeholder="Enter Name" />
              </div>
            </div>
            <div class="form-group row" v-if="!isSuiteType">
              <label for="suite-type" class="col-form-label col-md-3">Type:</label>
              <div class="col-md-9">
                <select name="suite-type" id="suite-type" class="form-control" v-model="typeId">
                  <option value="">Select Suite Type</option>
                  <option v-for="suiteType in suiteTypes" :value="suiteType.id" :key="suiteType.id">{{ suiteType.name }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="!isSuiteType">
              <label for="unit-number" class="col-form-label col-md-3">Unit #:</label>
              <div class="col-md-9">
                <input type="text" name="unit-number" id="unit-number" v-model="unit" class="form-control" placeholder="Enter Unit Number" />
              </div>
            </div>
            <div class="form-group row">
              <label for="status" class="col-form-label col-md-3">Status:</label>
              <div class="col-md-9">
                <select name="status" id="status" class="form-control" v-model="status">
                  <option value="">Select Status</option>
                  <option v-for="i in ['Available Now', 'Available Soon', 'Unavailable']" :value="i" :key="i">{{ i }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row" v-if="status === 'Available Soon'">
              <label for="available-on" class="col-form-label col-md-3">Available:</label>
              <div class="col-md-9">
                <input type="date" name="available-on" id="available-on" v-model="availableOn" class="form-control" placeholder="Select Date" />
              </div>
            </div>
            <div class="form-group row">
              <label for="monthly" class="col-form-label col-md-3">
                <span v-if="!isSuiteType">Monthly:</span>
                <span v-else>Starting From:</span>
              </label>
              <div class="col-md-9">
                <input type="text" name="monthly" id="monthly" v-model="rent" class="form-control" placeholder="Enter Monthly Cost" />
              </div>
            </div>
            <div class="form-group row" v-if="!isSuiteType">
              <label for="floor" class="col-form-label col-md-3">Floor:</label>
              <div class="col-md-9">
                <select name="floor" id="floor" class="form-control" v-model="floor">
                  <option value="">Select Floor</option>
                  <option v-for="i in 19" :value="i" :key="i">{{ i }}</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label for="sqfoot" class="col-form-label col-md-3">Sq ft:</label>
              <div class="col-md-9">
                <input type="text" name="sqfoot" id="sqfoot" v-model="size" class="form-control" placeholder="Enter Sq Ft" />
              </div>
            </div>
            <div class="form-group row">
              <label for="rooms" class="col-form-label col-md-3">Rooms:</label>
              <div class="col-md-5">
                <select name="rooms" id="rooms" class="form-control" v-model="numBedrooms">
                  <option value="">Select Rooms</option>
                  <option v-for="(n, i) in 4" :value="i" :key="i">{{ i }}</option>
                </select>
              </div>
              <div class="col-md-4">
                <select name="bathrooms" id="bathrooms" class="form-control" v-model="numBathrooms">
                  <option value="">Select Baths</option>
                  <option v-for="i in 2" :value="i" :key="i">{{ i }}</option>
                </select>
              </div>
            </div>
            <div class="form-group button-group error" v-if="error">
              <p>{{ error }}</p>
            </div>
            <div class="form-group button-group">
              <button type="submit" class="btn btn-red btn-block">
                <span class="spinner-border spinner-border-sm" role="status" v-if="isLoading"></span>
                <span v-else-if="suite">Update Suite</span>
                <span v-else>Add Suite</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import Dropzone from "dropzone";
import axios from "axios";

export default {
  name: 'EditSuite',
  data: function () {
    return {
      unit: "",
      status: "",
      availableOn: "",
      rent: "",
      size: "",
      numBedrooms: "",
      numBathrooms: "",
      floor: "",
      dropzone: null,
      isLoading: false,
      error: "",
      isSuiteType: false,
      name: "",
      typeId: "",
    };
  },
  props: [ 'open', 'close', 'suite', 'suiteTypes' ],
  computed: {
    hasUploadedFile: function() {
      return this.dropzone && this.dropzone.files.length > 0;
    },
  },
  watch: {
    open: function(newVal) {
      if (newVal === true) {
        if (this.suite != null) {
          if (this.suite.availableOn) {
            let availableDate = new Date(this.suite.availableOn);
            this.availableOn = availableDate.toLocaleDateString('en-US', {year: 'numeric'})
              + '-'
              + availableDate.toLocaleDateString('en-US', {month: '2-digit'})
              + '-'
              + availableDate.toLocaleDateString('en-US', {day: '2-digit'});
          }
          else {
            this.availableOn = '';
          }
          this.unit = this.suite.unit;
          this.rent = this.suite.rent;
          this.size = this.suite.size;
          this.numBedrooms = this.suite.numBedrooms;
          this.numBathrooms = this.suite.numBathrooms;
          this.floor = this.suite.floor;
          this.isSuiteType = this.suite.isSuiteType;
          this.name = this.suite.name;
          this.typeId = this.suite.typeId;

          if (this.suite.availableNow) {
            this.status = 'Available Now';
          }
          else if (this.suite.available) {
            this.status = 'Available Soon';
          }
          else {
            this.status = 'Unavailable';
          }
        }
        else {
          this.unit = "";
          this.status = "";
          this.availableOn = "";
          this.rent = "";
          this.size = "";
          this.numBedrooms = "";
          this.numBathrooms = "";
          this.floor = "";
          this.name = "";
          this.isSuiteType = false;
          this.typeId = "";
        }

        this.$nextTick(() => {
          this.dropzone = new Dropzone("div#upload", {
            url: '/',
            maxFiles: 1,
            autoProcessQueue: false,
            clickable: 'div#upload img, div#upload span',
          });
          this.dropzone.on('addedfile', () => {
            if (this.dropzone.files.length > 1) {
              this.dropzone.removeFile(this.dropzone.files[0]);
            }
          });
        });
      }
    }
  },
  mounted: function () {
    // 
  },
  methods: {
    save: function(e) {
      e.preventDefault();

      this.isLoading = false;
      this.error = "";

      let reqData = new FormData();
      reqData.append('unit', this.unit);
      reqData.append('numBedrooms', this.numBedrooms);
      reqData.append('numBathrooms', this.numBathrooms);
      reqData.append('size', this.size);
      reqData.append('rent', this.rent);
      reqData.append('floor', this.floor || '');
      reqData.append('available', this.status == 'Available Now');
      reqData.append('isSuiteType', this.isSuiteType == true);
      reqData.append('name', this.name);
      reqData.append('typeId', this.typeId || '');

      if (this.status == 'Available Soon') {
        reqData.append('availableOn', this.availableOn);
      }
      else {
        reqData.append('availableOn', '');
      }

      if (this.dropzone && this.dropzone.getAcceptedFiles()[0]) {
        reqData.append('floorplan', this.dropzone.getAcceptedFiles()[0]);
      }

      let reqUrl = "/api/suites/save";
      if (this.suite && this.suite.id) {
        reqUrl = `/api/suites/${this.suite.id}/save`;
      }

      this.isLoading = true;

      axios.post(reqUrl, reqData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        })
        .then((response) => {
          this.isLoading = false;

          if (this.suite) {
            this.suite.available = this.status == 'Available Now';
          }

          this.close(null, response.data.suite);
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            let errorStr = "";
            if (error.response.data.error) {
              errorStr = error.response.data.error;
            }
            else if (error.response.data.errors) {
              errorStr = error.response.data.errors[Object.keys(error.response.data.errors)[0]][0];
            }
            else {
              errorStr = error.response.data.message;
            }

            this.error = errorStr;
          }
          else {
            this.error = "Sorry, something went wrong. Please try again later."
          }
        });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

div.overlay {
  background: rgba(black, 0.5);
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

div.body {
  position: fixed;
  z-index: 11;
  right: 0;
  top: 0;
  bottom: 0;
  background: white;
  width: 550px;
  overflow-y: auto;
}

div.top {
  background: #F4F4F3;
  padding: 63px 23px 50px;

  div.title {
    display: flex;
    align-items: center;
    
    span {
      font-size: 1.25rem;
      font-weight: 500;
      color: #4A4A4A;
    }
  }

  div#upload {
    margin: 45px auto 0;
    background: #FFFFFF;
    border: 1px dashed #C0C0C0;
    width: 90%;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #4A4A4A;
    cursor: pointer;
    transition: background 250ms, border-color 250ms;

    > div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &:hover {
      background: darken(white, 2%);
      border-color: var(--accentColor);
    }

    span.large {
      font-size: 0.875rem;
      line-height: 1.14;
      margin: 14px 0 7px;
    }

    span.small {
      font-size: 0.75rem;

      strong {
        font-weight: 500;
        color: var(--accentColor);
      }
    }
  }
}

div.bottom {
  padding: 45px 50px;

  .form-group.row {
    align-items: center;
  }

  .suite-type-col {
    align-items: center;
    display: flex;

    label.check {
      margin: 0;
    }
  }
}

div.button-group {
  margin-top: 50px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.slide-enter-active, .slide-leave-active {
  transition: transform .25s;
}
.slide-enter, .slide-leave-to {
  transform: translateX(550px);
}
</style>
<style lang="scss">
div.dz-preview {
  div.dz-progress,
  div.dz-error-message,
  div.dz-success-mark,
  div.dz-error-mark {
    display: none;
  }

  div.dz-details {
    font-size: 0.875rem;
  }
}
</style>
